import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_TAGS = "GET_LIST_TAGS";
export const GET_DETAIL_TAGS = "GET_DETAIL_TAGS";
export const UPDATE_TAG = "UPDATE_TAG";
export const SAVE_TAG = "SAVE_TAG";
export const DELETE_TAG = "DELETE_TAG";
export const SET_LIST_TAGS = "SET_LIST_TAGS";
export const SET_DETAIL_TAGS = "SET_DETAIL_TAGS";


const state = {
    tag: [],
    tagDetail: []
};

const getters = {
    tags(state) {
        return state.tag;
    },
    tagDetail(state) {
        return state.tagDetail;
    },


};

const actions = {
    [GET_LIST_TAGS](context) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_LIST_TAGS}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_LIST_TAGS, data);
                }
                resolve(data);
            });
        });
    },
    [GET_DETAIL_TAGS](context,id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_TAGS}/${id}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_DETAIL_TAGS, data);
                }
                resolve(data);
            });
        });
    },
    [SAVE_TAG](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_TAG}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_TAG](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_TAG}`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [DELETE_TAG](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_TAG}`,id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

};

const mutations = {
    [SET_LIST_TAGS](state, data) {
        state.tag = data.data;
    },
    [SET_DETAIL_TAGS](state, data) {
        state.tagDetail = data.data;
    },


};

export default {
    state,
    actions,
    mutations,
    getters
};